module.exports = __webpack_public_path__ + "static/media/mh.5acc521d.svg";